import React from 'react'

interface TooltipProps {
  content: React.ReactNode
  children: React.ReactNode
  className?: string
  /** id for aria-describedby on the trigger */
  id?: string
}

/**
 * Lightweight hover/focus tooltip — paper panel, hairline border, editorial type.
 */
const Tooltip: React.FC<TooltipProps> = ({ content, children, className = '', id }) => (
  <span className={`relative inline-flex group ${className}`}>
    <span className="inline-flex min-w-0" tabIndex={0} aria-describedby={id}>
      {children}
    </span>
    <span
      id={id}
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-0 z-50 mb-1.5 w-max max-w-[16rem] opacity-0 translate-y-0.5 transition-[opacity,transform] duration-150 group-hover:opacity-100 group-hover:translate-y-0 group-focus-within:opacity-100 group-focus-within:translate-y-0"
    >
      <span className="block rounded-sm border border-rule bg-paper px-3 py-2 text-sm text-ink-700 shadow-[0_2px_8px_rgba(26,26,26,0.08)] leading-snug">
        {content}
      </span>
    </span>
  </span>
)

export default Tooltip
